module.exports = __webpack_public_path__ + "static/media/equipe.e3cc2c19.png";